export default __webpack_public_path__ + "static/media/strasbourg17.5fda0bd5.jpg";